export const sx = {
    root:{
        with:'100%'
    },
    alert:{
        with:'100%'
    }
}